<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form>
				  <c-form-item type="input" label="关联订单" name="order_number"></c-form-item>
                  <c-form-item type="select" label="费用类型" name="fee_code" :options="feeNameOptions" ></c-form-item>
                  <c-form-item type="datetime" label="创建时间" start-name="begin_time" end-name="end_time"></c-form-item>
                  <c-form-item type="select" label="结算状态" name="settlement_state" :options="state" ></c-form-item>
                  <c-form-item v-if="systemConfig.pt_mode == 2" type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
                </c-form>
			</m-search>
            <m-operate>
              <c-button color="m" hollow @click="syncExport()">导出</c-button>

              <template #right>
                  <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
              </template>
            </m-operate>
			<c-table ref="table">
                <c-table-column
                        label="关联订单"
                        name="order_number"
                        width="120"
                >
                </c-table-column>

                <c-table-column
                        label="费用类型"
                        name="fee_name"
                        width="130"
                >
                    <template v-slot="{data}">
                        <span v-if="data.fee_code=='105' &&data.settle_amount<0" style="color: red">
                          {{data.fee_name||'--'}}
                        </span>
                        <span v-else-if="data.fee_code=='2000'" style="color: red">
                          {{data.fee_name||'--'}}
                        </span>
                        <span v-else>{{data.fee_name||'--'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="清分状态"
                        name="settlement_state"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span v-if="data.settlement_state==1" style="color:darkgray">{{transStateName[data.settlement_state]}}</span>
                        <span v-if="data.settlement_state==2" style="color:brown">{{transStateName[data.settlement_state]}}</span>
                        <span v-if="data.settlement_state==3" style="color:darkgreen">{{transStateName[data.settlement_state]}}</span>
                        <span v-if="data.settlement_state==4" style="color:red">{{transStateName[data.settlement_state]}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="结算数量"
                        name="settled_count"
                        width="80"
                >
                    <template v-slot="{data}">
                        <span>{{data.settled_count||'--'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="结算费用"
                        name="settled_amount"
                        width="100"
                >
                    <template v-slot="{data}">
							<span v-if="data.settled_amount<0" style="color: red">
								￥{{parseFloat(Math.abs(data.settled_amount)).toFixed(2)}}
							</span>
                        <span v-else>￥{{parseFloat(data.settled_amount).toFixed(2)}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="清分到账账户"
                        name="return_type"
                        width="250"
                >
                    <template v-slot="{data}">
							<span v-if="data.account_type==1" style="color:forestgreen">
								【平台】
							</span>
                            <span v-if="data.account_type==2" style="color:#707070">
								【商家】
							</span>
                            <span v-if="data.account_type==1" style="color:forestgreen">{{data.account_name}}</span>
                            <span v-if="data.account_type==2" style="color:#707070">{{data.company_name}}
                                <span v-if="data.shop_name && data.shop_name!=data.company_name">【{{data.shop_name}}】</span>
							</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="预估结算数量"
                        name="settle_count"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.settle_count||'--'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="预估结算费用"
                        name="settle_amount"
                        width="110"
                >
                    <template v-slot="{data}">
							<span v-if="data.settle_amount<0" style="color: red">
								￥{{parseFloat(Math.abs(data.settle_amount)).toFixed(2)}}
							</span>
                        <span v-else>￥{{parseFloat(data.settle_amount).toFixed(2)}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="仅退款数量"
                        name="refund_count"
                        width="100"
                >
                    <template v-slot="{data}">
                        <span>{{data.refund_count||'--'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="仅退款金额"
                        name="refund_amount"
                        width="100"
                >
                    <template v-slot="{data}">
							<span v-if="data.settle_amount">
								￥{{parseFloat(data.refund_amount).toFixed(2)}}
							</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="退货退款数量"
                        name="return_count"
                        width="110"
                >
                    <template v-slot="{data}">
                        <span>{{data.return_count||'--'}}</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="退货退款金额"
                        name="return_amount"
                        width="110"
                >
                    <template v-slot="{data}">
							<span v-if="data.return_amount">
								￥{{parseFloat(data.return_amount).toFixed(2)}}
							</span>
                        <span v-else>--</span>
                    </template>
                </c-table-column>

                <c-table-column
                        label="关联商家"
                        name="shop_name"
                        width="200"
                        v-if="systemConfig.pt_mode == 2"
                >
                    <template v-slot="{data}">
                        {{data.company_name||'--'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="清分时间"
                        name="last_settled_date"
                        width="150"
                >
                    <template v-slot="{data}">
                        {{data.last_settled_date||'--'}}
                    </template>
                </c-table-column>

                <c-table-column
                        label="创建时间"
                        name="create_date"
                        width="150"
                ></c-table-column>

            </c-table>
		</module>
		
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'  // 商家库
	import {mapState} from 'vuex'
	export default {
		name: 'm_order_settlement',
		
		components: {
			stationedSelector
		},
		
		computed: {
            ...mapState(['systemConfig', 'userInfo']),
            feeNameOptions() {
                return (
                        [
                            {name: '商品货款',value:'1000'},
                            {name: '物流费',value:'9000'},
                            {name: '商家服务费',value:'105'},
                            {name: '平台补贴',value:'106'},
                        ].concat(this.systemConfig.share_enable == 'ON'?[
                            {name: '代理卡收益',value: '1001'},
                            {name: '分销奖励',value: '2000'}
                        ]:[])
                        .concat([
                            {name:"分享赚奖励",value:"2001"},
                            {name:"售后差额",value:"107"},
                            {name:"商品代发费",value:"102"},
                            {name:"技术服务费",value:"103"},
                            {name:"平台服务费",value:"101"}
                        ])
                );
            }
		},
		
		data() {
			return {
                workType:3,//业务类型，详见枚举【ExportTypeEnum】
                searchParams:{},
                operationMode: [
                    {name: '平台自营',value: 1},
                    {name: '商家自营',value: 2}
                ],
                transStateName: {
                    4: '取消结算',
                    1: '待结算',
                    2: '部分结算',
                    3: '全部结算'
                },
                state: [
                    {name: '待清分',value: 1},
                    {name: '部分结算',value: 2},
                    {name: '全部结算',value: 3},
                    {name: '取消结算',value: 4}
                ],
                orderTypeName: {
                    1: '普通',
                    2: '积分',
                    3: '赠品',
                    4: '砍价',
                    5: '预售订单(全款)',
                    6: '预售订单(定金)',
                    7: '定制',
                    8: '拼团',
                    9: '云仓提货',
                    10: '送礼',
                    11: '抽奖'
                }
			}
		},
		
		mounted() {
			this.$refs.search.search();
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.$refs.table.load({
					url: '/order/settlement/detail/list',
					data
				});
                this.searchParams = data||{};
			},

			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},

            /**
             * 同步导出数据
             * @param work_type
             */
            syncExport(){
                this.request({
                    url: '/export/url',
                    data: Object.assign({
                        work_type: this.workType //业务类型
                    },this.searchParams),
                    success: data => {
                        this.download({
                            fileName: data.filename,
                            url: data.url,
                            loading: {
                                message: '数据文件生成中...'
                            }
                        })
                    }
                });
            }
		}
	}
</script>